import React, { useEffect, useState, useContext } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import blogFetch from "../../axios/config";
import Button from "@mui/material/Button";
import { Modal } from "react-bootstrap";
import LoadingButton from "@mui/lab/LoadingButton";
import RegisterWorkInstructive from "./RegisterWorkInstructive";
import language from "../../nls/language.json";
import Context from "../../context/Context";

export default function WorkInstructive() {
  const [workInstructive, setWorkInstructive] = useState([]);
  const [workInstructiveId, setWorkInstructiveId] = useState();
  const [showFile, setShowFile] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  const { useRef } = React;
  const ref = useRef();
  useEffect(() => {
    getWorkInstructive();
  }, []);

  const getWorkInstructive = async () => {
    try {
      let response = await blogFetch.get("/WorkInstructive");
      let data = response.data;
      setWorkInstructive(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getDocuments = async (code) => {
    try {
      let response = await blogFetch.get("/Documents/"+code);
      let data = response.data;
      let url = data.doC_fileUrl;
      let fullUrl = url+ "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2033-06-06T23:22:22Z&st=2023-06-06T15:22:22Z&spr=https,http&sig=AmNdgNEWKNvsjgz%2BfwYJKb7l1nBWV%2F5V34UqWHQ0n%2FY%3D"
      return fullUrl
    } catch (error) {
      console.error(error);
    }
  };
  const modalAdd = () => {
    return (
      <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Instrutivos.modal.adicionar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterWorkInstructive ref={ref}></RegisterWorkInstructive>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalAdd(false)}
          >
            {language[selectedCountry.name].Instrutivos.modal.adicionar.btnCancelar}
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.addInstructive();
                setLoading(false);
                setShowModalAdd(false);
                getWorkInstructive();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {language[selectedCountry.name].Instrutivos.modal.adicionar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalUpdate = () => {
    return (
      <Modal show={showModalUpdate} onHide={() => setShowModalUpdate(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Instrutivos.modal.editar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterWorkInstructive
            workInstructiveId={workInstructiveId}
            ref={ref}
          ></RegisterWorkInstructive>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalUpdate(false)}
          >
            {language[selectedCountry.name].Instrutivos.modal.editar.btnCancelar}
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.updateInstructive();
                setLoading(false);
                setShowModalAdd(false);
                getWorkInstructive();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {language[selectedCountry.name].Instrutivos.modal.editar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
              {language[selectedCountry.name].Instrutivos.title}
            </h3>
          </div>

          <div>
            <Button
              className="add_button"
              variant="contained"
              onClick={() => setShowModalAdd(true)}
            >
              {language[selectedCountry.name].Instrutivos.btnAdicionar}
            </Button>
          </div>
        </div>
        <table className="table table-hover">
          <thead className="table-header">
            <tr className="table_row">
              <th>#</th>
              <th>{language[selectedCountry.name].Instrutivos.tableHeader.nome}</th>
              <th>{language[selectedCountry.name].Instrutivos.tableHeader.codigo}</th>
              <th>{language[selectedCountry.name].Instrutivos.tableHeader.descricao}</th>
              <th>{language[selectedCountry.name].Instrutivos.tableHeader.setor}</th>
              <th className="edit">{language[selectedCountry.name].Instrutivos.tableHeader.arquivo}</th>
              <th className="edit">{language[selectedCountry.name].Instrutivos.tableHeader.editar}</th>
            </tr>
          </thead>
          <tbody className="table_row">
            {!!workInstructive &&
              Object.entries(workInstructive).map((item) => (
                <tr key={item[1].wrK_PK_idWorkInstructive}>
                  <td>{item[1].wrK_PK_idWorkInstructive}</td>
                  <td>{item[1].wrK_name}</td>
                  <td>{item[1].wrK_code}</td>
                  <td>{item[1].wrK_description}</td>
                  <td>{item[1].sector.stR_description}</td>
                  <td className="edit">
                    <center>
                      <FileOpenIcon
                        onClick={async () => {
                          let url = await getDocuments(item[1].wrK_code)
                          window.open(url, '_blank', 'noreferrer')

                        }}
                      />
                    </center>
                  </td>
                  <td className="edit">
                    <center>
                      <ModeEditIcon
                        onClick={() => {
                          setWorkInstructiveId(
                            item[1].wrK_PK_idWorkInstructive
                          );
                          setShowModalUpdate(true);
                        }}
                      />
                    </center>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {modalAdd()}
      {modalUpdate()}
    </>
  );
}
